const categories = {
  SIGN_UP: 'Sign Up Page',
  DOWNLOAD: 'Download Page',
  GLOBAL: 'Global Actions',
  TEAMS: 'Teams',
};

export default {
  SIGN_UP_EMAIL_OPT_IN: {
    eventCategory: categories.SIGN_UP,
    eventAction: 'Email Opt-In',
    eventNonInteraction: true,
  },
  SIGN_UP_SUCCESS: {
    eventCategory: categories.SIGN_UP,
    eventAction: 'Sign Up Success',
    eventLabel: 'Email',
    eventNonInteraction: true,
  },
  INSTALLER_AUTO_DOWNLOAD_START: {
    eventCategory: categories.DOWNLOAD,
    eventAction: 'Download Start',
    eventLabel: 'Auto',
    eventNonInteraction: true,
  },
  SIGNUP_FORM_OPEN: {
    eventCategory: categories.SIGN_UP,
    eventAction: 'Open Form',
    eventNonInteraction: true,
  },
  SIGNUP_FORM_STEP_EMAIL_NEW: {
    eventCategory: categories.SIGN_UP,
    eventAction: 'Enter Email',
    eventLabel: 'New Email',
    eventNonInteraction: true,
  },
  SIGNUP_FORM_STEP_EMAIL_EXISTING: {
    eventCategory: categories.SIGN_UP,
    eventAction: 'Enter Email',
    eventLabel: 'Existing Email',
    eventNonInteraction: true,
  },
  SIGNUP_FORM_STEP_PASSWORD: {
    eventCategory: categories.SIGN_UP,
    eventAction: 'Create Password',
    eventNonInteraction: true,
  },
  SIGNUP_FORM_STEP_USERNAME: {
    eventCategory: categories.SIGN_UP,
    eventAction: 'Create Nickname',
    eventNonInteraction: true,
  },
  SIGNUP_FORM_SOCIAL_AUTH_GOOGLE: {
    eventCategory: categories.SIGN_UP,
    eventAction: 'Click Google',
    eventNonInteraction: true,
  },
  SIGNUP_FORM_SOCIAL_AUTH_FACEBOOK: {
    eventCategory: categories.SIGN_UP,
    eventAction: 'Click Facebook',
    eventNonInteraction: true,
  },
  SEARCH_USED: {
    eventCategory: categories.GLOBAL,
    eventAction: 'Search Used',
    eventNonInteraction: false,
  },
  BOOK_DEMO: {
    eventCategory: categories.TEAMS,
    eventAction: 'Click Book a Demo',
    eventNonInteraction: false,
  },
};
